module.exports = __webpack_public_path__ + "img/account-menu-icon.ceaab784.svg";